import { getAuthToken, getStaff } from "./auth-utils";

const user = getStaff();
const token = getAuthToken();
// let school =
//   localStorage.getItem('school') != undefined
//     ? JSON.parse(localStorage.getItem('school'))
//     : {};
let jspPrimary = localStorage.getItem('jsp-primary');
let permissions =
  localStorage.getItem('jsp_staff_permissions') != undefined
    ? JSON.parse(localStorage.getItem('jsp_staff_permissions'))
    : null;
let jspTheme = localStorage.getItem('theme');

let jspStaffPermissions = [];
const environment = window.location.hostname;
 
let host;

// if(environment === 'localhost') host = 'http://127.0.0.1:8000';else host = 'https://api.jspnigeria.com';
if(environment === 'localhost' || environment === 'eum.tespire.co') host = 'https://api-staging.tespire.ng';else host = 'https://api.tespire.ng';

permissions !== null &&
  permissions.forEach((permission) =>
    jspStaffPermissions.push(permission.name)
  );

const data = {
  // school: school,
  get school() {
    try {
      return JSON.parse(localStorage.getItem("school") || "{}");
    } catch {
      return {};
    }
  },
  staff: user != undefined ? user : '',
  jspPrimary: jspPrimary,
  theme: jspTheme,
  jspStaffPermissions: jspStaffPermissions,
  host:  host,
  // host: 'http://192.168.105.116:8005'',
  // host: 'https://applicants.ibbuiceel.jdlabserver.com/',
  // cloud: 'https://filesupload.jdlabserver.com',
  // printHost: 'https://www.jsp.ng/',
  token: token != undefined ? token : '',
  // id: applicant != undefined ? applicant.id : '',
  headers: {
    'Content-Type':'application/json',
    Authorization: `Bearer ${token != undefined ? token : ''}`,
    xtenant: environment === 'localhost' ? 'eum.tespire.co' : environment
    // xtenant: environment === 'localhost' ? 'somidminna.tespire.co' : environment
    // xtenant: environment === 'localhost' ? 'ibbuiceel.tespire.co' : environment
     //xtenant: 'eum.jspnigeria.com'
    // xtenant: 'coeminna.jspnigeria.com'
  }
};

export default data;
